import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SvgService {
  private cache = new Map<string, Observable<string>>();

  constructor(private http: HttpClient) {
    this.preloadToastIcons();
  }

  private preloadToastIcons() {
    const icons = [
      'assets/common/toast/warn.svg',
      'assets/common/toast/error.svg',
      'assets/common/toast/info.svg',
      'assets/common/toast/success.svg',
    ];
    icons.forEach((path) => this.getSvg(path).subscribe());
  }

  getSvg(path: string): Observable<string> {
    if (!this.cache.has(path)) {
      this.cache.set(path, this.http.get(path, { responseType: 'text' }).pipe(shareReplay(1)));
    }
    return this.cache.get(path)!;
  }
}
